import type { IDedicatedResourceRef } from "@gettactic/api";

/**
 * The agenda's selected item when the person clicked their dedicated desk
 * card: the dashboard's details column shows the desk instead of a
 * reservation. Sits next to reservations and visits in `selectedEvent`.
 */
export interface DedicatedDeskSelection {
  kind: "dedicated_desk";
  desk: IDedicatedResourceRef;
  /** The agenda day the card was clicked on, `yyyy-MM-dd`. */
  date: string;
}

export const selectDedicatedDesk = (
  desk: IDedicatedResourceRef,
  date: string
): DedicatedDeskSelection => ({ kind: "dedicated_desk", desk, date });

export const isDedicatedDeskSelection = (
  event: unknown
): event is DedicatedDeskSelection =>
  !!event &&
  typeof event === "object" &&
  (event as { kind?: unknown }).kind === "dedicated_desk";
